<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/cataloge-mapping/sales" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditSalesCatalogue") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Name')"
              >
                <vs-input
                  v-if="teamData && teamData.salesCatalogeData && teamData.salesCatalogeData.name"
                  :label="$t('setup.label.Name')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.salesCatalogeData.name"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.SalesPlanCategory")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SalesPlanCategory')"
                >
                  <v-select
                    v-if="teamData && teamData.salesCatalogeData && teamData.salesCatalogeData.salesPlanCategoryId"
                    label="mCodeValue"
                    :options="teamById.salesPlanCategoryData"
                    v-model="teamData.salesCatalogeData.salesPlanCategoryId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="dual-listbox-wrapper">
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.AvailablePlans") }}
                  </h6>
                  <input
                    v-model="searchSource"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredSourcePlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedSourcePlans === plan.id ? 'active' : '',
                    ]"
                    @click="selectedSourcePlans = plan.id"
                  >
                      {{ plan.planCode }}
                  </li>
                </ul>
              </div>
        
              <div class="arrow-buttons">
                <button
                  class="arrow-button"
                  :disabled="!selectedSourcePlans"
                  @click="moveToTarget"
                >
                  <feather-icon icon="ArrowRightIcon" svgClasses="text-dark" />
                </button>
                <button
                  class="arrow-button"
                  :disabled="!selectedTargetPlans"
                  @click="moveToSource"
                >
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                </button>
              </div>
        
              <div class="listbox">
                <div class="listbox-header">
                  <h6 class="text-left font-bold">
                    {{ $t("setup.label.SelectedPlans") }}
                  </h6>
                  <input
                    v-model="searchTarget"
                    :placeholder="$t('setup.label.Search')"
                    class="border search-box rounded p-2 w-1/2"
                  />
                </div>
                <ul class="listbox-body">
                  <li
                    v-for="plan in filteredTargetPlans"
                    :key="plan.id"
                    :class="[
                      'listbox-item',
                      selectedTargetPlans === plan.id ? 'active' : '',
                    ]"
                    @click="selectedTargetPlans = plan.id"
                  >
                      {{ plan.planCode }}
                  </li>
                </ul>
              </div>
            </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateSalesCataloge"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const teamEmptyObj = {
  locale: "en",
  name: "",
  planDetails: [],
  salesPlanCategoryId: "",
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      teamData: teamEmptyObj,
      plansInit: {},
      selectedSourcePlans: null,
      selectedTargetPlans: null,
      searchSource: "",
      searchTarget: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      teamById: (state) => state.catalogueMapping.EditViewSalesCatalogeList,
    }),
    filteredSourcePlans() {
      if (this.plansInit && this.plansInit.sourcePlans) {
        return this.plansInit.sourcePlans.filter(
          (d) =>
            d.planCode.toLowerCase().includes(this.searchSource.toLowerCase())
        );
      } else {
        return null;
      }
    },
    filteredTargetPlans() {
      if (this.plansInit && this.plansInit.targetPlans) {
        return this.plansInit.targetPlans.filter(
          (d) =>
            d.planCode.toLowerCase().includes(this.searchTarget.toLowerCase())
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    moveToTarget() {
      if (!this.selectedSourcePlans) return;

      const selectedPlan = this.plansInit.sourcePlans.find(
        (discount) => discount.id === this.selectedSourcePlans
      );

      if (selectedPlan) {
        this.plansInit.targetPlans.push(selectedPlan);
        this.plansInit.sourcePlans =
          this.plansInit.sourcePlans.filter(
            (discount) => discount.id !== this.selectedSourcePlans
          );
        this.selectedSourcePlans = null;
      }
    },

    moveToSource() {
      if (!this.selectedTargetPlans) return;

      const selectedPlan = this.plansInit.targetPlans.find(
        (discount) => discount.id === this.selectedTargetPlans
      );

      if (selectedPlan) {
        this.plansInit.sourcePlans.push(selectedPlan);
        this.plansInit.targetPlans =
          this.plansInit.targetPlans.filter(
            (discount) => discount.id !== this.selectedTargetPlans
          );
        this.selectedTargetPlans = null;
      }
    },
    initializePlans() {
     const allPlans = (this.teamData && this.teamData.plans) || [];
     const selectedPlans = this.teamData && this.teamData.selectedPlans ? [...this.teamData.selectedPlans] : [];

  if (selectedPlans.length > 0) {

    const targetPlans = selectedPlans

    const sourcePlans = allPlans

    this.$set(this, "plansInit", {
      sourcePlans,
      targetPlans,
    });
  } else {
    this.$set(this, "plansInit", {
      sourcePlans: [...allPlans],
      targetPlans: [],
    });
  }

  this.selectedSourcePlans = null;
  this.selectedTargetPlans = null;
    },
    async editViewSAlesCataloge() {
      try {
        await this.$store.dispatch(
          "catalogueMapping/seteditViewSAlesCataloge",
          this.id
        );
        this.teamData = this.teamById;
        this.initializePlans();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateSalesCataloge() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const selectedPlanIds = this.plansInit.targetPlans.map(plan => plan.id);
        this.teamData.planDetails = selectedPlanIds;

        this.teamData.name = this.teamData.salesCatalogeData.name;
        this.teamData.salesPlanCategoryId =
          this.teamData.salesCatalogeData.salesPlanCategoryId;
        this.teamData.locale = "en";
        delete this.teamData.plans;
        delete this.teamData.salesCatalogeData;
        delete this.teamData.salesPlanCategoryData;
        delete this.teamData.selectedPlans;

        await this.$store.dispatch(
          "catalogueMapping/updateSalesCatalogeAction",
          {
            id: this.id,
            data: this.teamData,
          }
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Sales Cataloge Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/cataloge-mapping/sales`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },

    resetForm() {
      this.teamData = teamEmptyObj;
    },
    cancel() {
      this.$router.push(`/setup/cataloge-mapping/sales`);
    },
  },

  created() {},
  async mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    await this.editViewSAlesCataloge();
  },
};
</script>
<style scoped>
  .dual-listbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
}
.listbox {
  width: -webkit-fill-available;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #fff;
  display: flex;
  flex-direction: column;
}
.listbox-header {
  background-color: #2e68b266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.listbox-body {
  overflow-y: auto;
  flex-grow: 1;
  margin: 0;
  padding: 10px;
  list-style: none;
}
.listbox-item {
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
}
.listbox-item:hover {
  background-color: #f0f8ff;
}
.listbox-item.active {
  background-color: #e2e9f5;
  font-weight: bold;
}
.arrow-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.arrow-button {
  padding: 8px;
  border: none;
  background-color: #eee;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0;
}
.arrow-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
